import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal right fade",
  id: "opModal",
  tabindex: "-1",
  "aria-labelledby": "OperationCreateModalLabel",
  style: {"z-index":"1055"},
  "data-bs-keyboard": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "headerText",
  id: "OperationCreateModalLabel",
  style: {"color":"white"}
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = {
  key: 0,
  style: {"position":"relative","z-index":"999999","top":"22rem"}
}
const _hoisted_9 = { style: {"position":"relative"} }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "expandToComponents"
}
const _hoisted_12 = { class: "entry" }
const _hoisted_13 = { class: "inputGroup" }
const _hoisted_14 = {
  class: "label",
  for: "tbox1"
}
const _hoisted_15 = { class: "team" }
const _hoisted_16 = {
  class: "label",
  for: "team"
}
const _hoisted_17 = { class: "body" }
const _hoisted_18 = {
  class: "label",
  for: "description"
}
const _hoisted_19 = ["placeholder", "value"]
const _hoisted_20 = { class: "counter" }
const _hoisted_21 = {
  key: 2,
  class: "stitchType-row",
  style: {"display":"flex","align-items":"flex-end","gap":"24px"}
}
const _hoisted_22 = {
  class: "stitchTypeWide",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_23 = {
  class: "label1",
  for: "operationType"
}
const _hoisted_24 = {
  class: "stitchType-row",
  style: {"display":"flex","align-items":"flex-end","gap":"24px"}
}
const _hoisted_25 = {
  class: "stitchTypeWide",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_26 = {
  class: "label1",
  for: "stitchType"
}
const _hoisted_27 = {
  key: 0,
  class: "formComponent"
}
const _hoisted_28 = {
  key: 0,
  class: "label",
  for: "seamlength"
}
const _hoisted_29 = {
  key: 1,
  class: "label",
  for: "seamlength"
}
const _hoisted_30 = {
  key: 2,
  class: "label",
  for: "seamlength"
}
const _hoisted_31 = {
  key: 1,
  class: "formComponent"
}
const _hoisted_32 = {
  key: 0,
  class: "label",
  for: "stitch"
}
const _hoisted_33 = {
  key: 1,
  class: "label",
  for: "stitch"
}
const _hoisted_34 = {
  key: 0,
  class: "formComponent"
}
const _hoisted_35 = {
  class: "label",
  for: "quantity"
}
const _hoisted_36 = { class: "formComponent" }
const _hoisted_37 = {
  class: "label",
  for: "machines"
}
const _hoisted_38 = {
  key: 1,
  class: "formComponent"
}
const _hoisted_39 = {
  class: "label",
  for: "seamThickness"
}
const _hoisted_40 = {
  key: 3,
  class: "bight-row"
}
const _hoisted_41 = {
  class: "formComponent",
  style: {"width":"25.5% !important","margin-top":"10px"}
}
const _hoisted_42 = {
  key: 0,
  class: "label",
  for: "bight"
}
const _hoisted_43 = {
  key: 1,
  class: "label",
  for: "bight"
}
const _hoisted_44 = {
  key: 4,
  class: "seam-details-box"
}
const _hoisted_45 = { class: "seam-row" }
const _hoisted_46 = { for: "numberOfPlies" }
const _hoisted_47 = { class: "seam-row" }
const _hoisted_48 = { for: "avgMaterialThickness" }
const _hoisted_49 = { class: "seam-row" }
const _hoisted_50 = { for: "avgButtonThickness" }
const _hoisted_51 = { class: "seam-row" }
const _hoisted_52 = { for: "avgThreadDiameter" }
const _hoisted_53 = { class: "seam-row" }
const _hoisted_54 = { for: "wastage" }
const _hoisted_55 = {
  key: 0,
  class: "seam-row"
}
const _hoisted_56 = { for: "needleDistance" }
const _hoisted_57 = ["max"]
const _hoisted_58 = {
  key: 1,
  class: "seam-value"
}
const _hoisted_59 = { class: "footer" }
const _hoisted_60 = {
  key: 0,
  class: "child"
}
const _hoisted_61 = { class: "needlesTable" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { style: {"text-align":"left"} }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { style: {"text-align":"left"} }
const _hoisted_66 = {
  key: 0,
  class: "componentCount"
}
const _hoisted_67 = {
  key: 0,
  colspan: "4",
  class: "chosenPerComponent"
}
const _hoisted_68 = {
  key: 1,
  class: "wastageNote"
}
const _hoisted_69 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GridLoading = _resolveComponent("GridLoading")!
  const _component_AlertComponent = _resolveComponent("AlertComponent")!
  const _component_toggle_button = _resolveComponent("toggle-button")!
  const _component_ComboBox = _resolveComponent("ComboBox")!

  return (_ctx.showPopup)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "close",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDialogClose && _ctx.handleDialogClose(...args)), ["prevent"]))
              }, [...(_cache[28] || (_cache[28] = [
                _createElementVNode("span", { "aria-hidden": "true" }, [
                  _createElementVNode("i", {
                    class: "fa fa-times",
                    style: {"color":"#fff !important","font-weight":"bold","font-size":"16px"}
                  })
                ], -1)
              ]))]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.newOperation), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["operation", { 'v4-op-layout': _ctx.isV4CalculationEngine }])
                }, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_GridLoading)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isCancelButtonClicked)
                    ? (_openBlock(), _createBlock(_component_AlertComponent, {
                        key: 1,
                        onSetWindow: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('visibleDialog', false))),
                        isCancelButtonClicked: _ctx.isCancelButtonClicked,
                        onHidePopup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isCancelButtonClicked = false)),
                        "z-index": "9999"
                      }, null, 8, ["isCancelButtonClicked"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "btn btn-primary",
                      style: {"width":"7rem","border-radius":"7px"},
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSaveOperationData && _ctx.onSaveOperationData(...args)))
                    }, _toDisplayString(_ctx.$t("operationCreateComp.save")), 1),
                    _createElementVNode("img", {
                      style: {"padding":"28px","height":"121px","width":"175px"},
                      src: _ctx.imageUrl,
                      alt: "Selected Stitch"
                    }, null, 8, _hoisted_10),
                    (_ctx.isMultiComponentThreadEnabled)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
                          _createTextVNode(_toDisplayString(_ctx.$t("editComponent.expandToComponents")) + " ", 1),
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.operationInputData.isMultiComponentThread) = $event)),
                            onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onExpandToComponentsChange && _ctx.onExpandToComponentsChange(...args)))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.operationInputData.isMultiComponentThread]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("operationCreateComp.group")), 1),
                        _withDirectives(_createElementVNode("input", {
                          class: "input",
                          type: "number",
                          id: "tbox1",
                          name: "tbox1",
                          min: "1",
                          value: "operationInputData.group",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.operationInputData.group) = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.operationInputData.group]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("operationCreateComp.team")), 1),
                        _createElementVNode("div", null, [
                          _createVNode(_component_toggle_button, {
                            modelValue: _ctx.operationInputData.isOnTeam,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.operationInputData.isOnTeam) = $event)),
                            height: 22,
                            width: 50,
                            checkedText: "On",
                            uncheckedText: "Off",
                            checkedBg: " #0054a6",
                            uncheckedBg: "lightgrey",
                            color: "#0054a6"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("operationCreateComp.description")), 1),
                    _createElementVNode("textarea", {
                      name: "tbox1",
                      class: _normalizeClass(["textArea", { errorStyle: _ctx.descHasError }]),
                      maxlength: 225,
                      placeholder: _ctx.addDescription,
                      rows: "4",
                      cols: "33",
                      value: _ctx.operationInputData.description,
                      onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setDescriptionCounter($event.target))),
                      required: "",
                      id: "description"
                    }, null, 42, _hoisted_19),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.count) + "/225", 1)
                  ]),
                  (_ctx.isV4CalculationEngine)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("editComponent.operationType")), 1),
                          _createVNode(_component_ComboBox, {
                            id: "operationType",
                            "data-source": _ctx.operationTypeOptions,
                            "data-text-field": 'label',
                            "data-value-field": 'value',
                            class: _normalizeClass({ errorStyle: _ctx.operationTypeHasError }),
                            height: 275,
                            filter: 'contains',
                            placeholder: 'Select',
                            modelValue: _ctx.operationInputData.operationType,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.operationInputData.operationType) = $event)),
                            onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleOperationTypeChange($event.sender._cascadedValue))),
                            style: { width: '100% !important' }
                          }, null, 8, ["data-source", "class", "modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("operationCreateComp.stitchType")), 1),
                      _createVNode(_component_ComboBox, {
                        ref: "stitchData",
                        "data-source": _ctx.stitchTypeData?.[0],
                        class: _normalizeClass({ errorStyle: _ctx.stitchHasError }),
                        height: 275,
                        maxlength: 30,
                        filter: 'contains',
                        placeholder: 'Select',
                        modelValue: _ctx.operationInputData.stitchTypeCode,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.operationInputData.stitchTypeCode) = $event)),
                        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getStitchCode($event.sender._cascadedValue))),
                        style: { width: '100% !important' }
                      }, null, 8, ["data-source", "class", "modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.showSeamLength)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          (_ctx.isV4CalculationEngine && ['BH', 'BT', 'BS', 'AC'].includes(_ctx.operationInputData.operationType))
                            ? (_openBlock(), _createElementBlock("label", _hoisted_28, _toDisplayString(_ctx.$t("operationCreateComp.stitchCount")), 1))
                            : (_ctx.seamLengthUnit == 0)
                              ? (_openBlock(), _createElementBlock("label", _hoisted_29, _toDisplayString(_ctx.$t("operationCreateComp.seamLength")) + "(Cm)", 1))
                              : (_openBlock(), _createElementBlock("label", _hoisted_30, _toDisplayString(_ctx.$t("operationCreateComp.seamLength")) + "(inch)", 1)),
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass(["input", { errorStyle: _ctx.seamLengthHasError }]),
                            type: "number",
                            min: "0",
                            step: ".01",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.operationInputData.seamLength) = $event)),
                            required: "",
                            style: {"width":"9em !important"},
                            id: "seamlength"
                          }, null, 2), [
                            [_vModelText, _ctx.operationInputData.seamLength]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showRate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          (_ctx.seamLengthUnit == 0)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_32, _toDisplayString(_ctx.$t("operationCreateComp.stitch")) + "/3Cm", 1))
                            : (_openBlock(), _createElementBlock("label", _hoisted_33, _toDisplayString(_ctx.$t("operationCreateComp.stitch")) + "/inch", 1)),
                          _withDirectives(_createElementVNode("input", {
                            class: "input",
                            type: "number",
                            min: "0",
                            step: ".01",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.operationInputData.rate) = $event)),
                            style: {"width":"9em !important"},
                            id: "stitch"
                          }, null, 512), [
                            [_vModelText, _ctx.operationInputData.rate]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    (_ctx.showQuantity)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("operationCreateComp.row/Quantity")), 1),
                          _withDirectives(_createElementVNode("input", {
                            class: "input",
                            type: "number",
                            min: "1",
                            step: ".01",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.operationInputData.quantity) = $event)),
                            style: {"width":"9em !important"},
                            id: "quantity"
                          }, null, 512), [
                            [_vModelText, _ctx.operationInputData.quantity]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("operationCreateComp.machines")), 1),
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["input", { errorStyle: _ctx.machineHasError }]),
                        type: "number",
                        min: "1",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.operationInputData.machines) = $event)),
                        required: "",
                        style: {"width":"9em !important"},
                        id: "machines"
                      }, null, 2), [
                        [_vModelText, _ctx.operationInputData.machines]
                      ])
                    ]),
                    (_ctx.showSeamThickness && !_ctx.isV4CalculationEngine)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("operationCreateComp.seamThickness")) + "(mm)", 1),
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass(["input", { errorStyle: _ctx.seamThicknessHasError }]),
                            type: "number",
                            min: "1",
                            step: ".1",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.operationInputData.seamThikness) = $event)),
                            style: {"width":"9em !important"},
                            id: "seamThickness"
                          }, null, 2), [
                            [_vModelText, _ctx.operationInputData.seamThikness]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.showBight)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          (_ctx.seamLengthUnit == 0)
                            ? (_openBlock(), _createElementBlock("label", _hoisted_42, _toDisplayString(_ctx.$t("operationCreateComp.bight")) + "(mm)", 1))
                            : (_openBlock(), _createElementBlock("label", _hoisted_43, _toDisplayString(_ctx.$t("operationCreateComp.bight")) + "(inch)", 1)),
                          _withDirectives(_createElementVNode("input", {
                            class: _normalizeClass(["input", { errorStyle: _ctx.bightHasError }]),
                            type: "number",
                            min: "0",
                            step: ".01",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.operationInputData.bight) = $event)),
                            onInput: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onBightChange && _ctx.onBightChange(...args))),
                            style: {"width":"9em !important"},
                            id: "bight"
                          }, null, 34), [
                            [_vModelText, _ctx.operationInputData.bight]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isV4CalculationEngine)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createElementVNode("fieldset", null, [
                          _createElementVNode("legend", null, _toDisplayString(_ctx.$t("editComponent.seamDetails")), 1),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("editComponent.numberOfPlies")), 1),
                            _withDirectives(_createElementVNode("input", {
                              class: "seam-input",
                              type: "number",
                              min: "1",
                              max: "999999",
                              step: "1",
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.operationInputData.numberOfPlies) = $event)),
                              id: "numberOfPlies"
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.operationInputData.numberOfPlies,
                                void 0,
                                { number: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t("editComponent.averageMaterialThickness")) + " (" + _toDisplayString(_ctx.unitLabel) + ")", 1),
                            _withDirectives(_createElementVNode("input", {
                              class: "seam-input",
                              type: "number",
                              min: "0",
                              max: "999.99999",
                              step: "0.00001",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.materialThicknessDisplay) = $event)),
                              id: "avgMaterialThickness"
                            }, null, 512), [
                              [_vModelText, _ctx.materialThicknessDisplay]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t("editComponent.averageButtonThickness")) + " (" + _toDisplayString(_ctx.unitLabel) + ")", 1),
                            _withDirectives(_createElementVNode("input", {
                              class: "seam-input",
                              type: "number",
                              min: "0",
                              max: "999.99999",
                              step: "0.00001",
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.buttonThicknessDisplay) = $event)),
                              id: "avgButtonThickness"
                            }, null, 512), [
                              [_vModelText, _ctx.buttonThicknessDisplay]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t("editComponent.averageThreadDiameter")) + " (" + _toDisplayString(_ctx.unitLabel) + ")", 1),
                            _withDirectives(_createElementVNode("input", {
                              class: "seam-input",
                              type: "number",
                              min: "0",
                              max: "999.99999",
                              step: "0.00001",
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.threadDiameterDisplay) = $event)),
                              id: "avgThreadDiameter"
                            }, null, 512), [
                              [_vModelText, _ctx.threadDiameterDisplay]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t("editComponent.wastagePerSeam")) + " (" + _toDisplayString(_ctx.unitLabel) + ")", 1),
                            _withDirectives(_createElementVNode("input", {
                              class: "seam-input",
                              type: "number",
                              min: "0",
                              max: "99999.99",
                              step: "0.01",
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.wastagePerSeamDisplay) = $event)),
                              id: "wastage"
                            }, null, 512), [
                              [_vModelText, _ctx.wastagePerSeamDisplay]
                            ])
                          ]),
                          (_ctx.showNeedleDistance)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t("editComponent.needleDistance")) + " (" + _toDisplayString(_ctx.unitLabel) + ")", 1),
                                (_ctx.isNeedleDistanceEditable)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      class: _normalizeClass(["seam-input", { errorStyle: _ctx.needleDistanceHasError }]),
                                      type: "number",
                                      min: "0",
                                      max: _ctx.needleDistanceMax,
                                      step: "0.01",
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.needleDistanceDisplay) = $event)),
                                      id: "needleDistance"
                                    }, null, 10, _hoisted_57)), [
                                      [_vModelText, _ctx.needleDistanceDisplay]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.needleDistanceDisplay), 1))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_59, [
                    (_ctx.showHeader)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createElementVNode("table", _hoisted_61, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t("operationCreateComp.component")), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.consumptionHeader), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t("editComponent.brand")), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.ticketTex == "Tkt" ? _ctx.$t("editComponent.tkt") : _ctx.$t("editComponent.tex")), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t("editComponent.shade")), 1),
                                _createElementVNode("th", null, _toDisplayString(_ctx.$t("editComponent.packageSize")), 1)
                              ])
                            ]),
                            (!_ctx.operationInputData.isMultiComponentThread)
                              ? (_openBlock(), _createElementBlock("tbody", _hoisted_62, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentsData, (items, id) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: id }, [
                                      _createElementVNode("td", _hoisted_63, _toDisplayString(items.name), 1),
                                      _createElementVNode("td", null, _toDisplayString(_ctx.consumptionValues[id]), 1),
                                      _createElementVNode("td", null, [
                                        (_ctx.brandData.length)
                                          ? (_openBlock(), _createBlock(_component_ComboBox, {
                                              "data-source": _ctx.brandData.length ? _ctx.brandData : [],
                                              "data-text-field": 'text',
                                              height: 130,
                                              "data-value-field": 'value',
                                              filter: 'contains',
                                              key: 'id',
                                              modelValue: _ctx.brandIdDataArray[id],
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.brandIdDataArray[id]) = $event),
                                              value: _ctx.brandIdDataArray[id],
                                              style: {"width":"10em !important","font-size":"12px !important"},
                                              onChange: ($event: any) => (_ctx.handleBrandChange($event.sender._cascadedValue, id))
                                            }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "value", "onChange"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("td", null, [
                                        (_openBlock(), _createBlock(_component_ComboBox, {
                                          "data-source": _ctx.tktTexData[id] && _ctx.tktTexData[id].length ? _ctx.tktTexData[id] : [],
                                          "data-text-field": 'text',
                                          "data-value-field": 'value',
                                          height: 130,
                                          filter: 'contains',
                                          key: 'id',
                                          modelValue: _ctx.tktTexDataArray[id],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.tktTexDataArray[id]) = $event),
                                          value: _ctx.tktTexDataArray[id],
                                          style: {"width":"7em !important","font-size":"12px !important"},
                                          onChange: ($event: any) => (_ctx.handleTktTexChange($event.sender._cascadedValue, id))
                                        }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "value", "onChange"]))
                                      ]),
                                      _createElementVNode("td", null, [
                                        (_openBlock(), _createBlock(_component_ComboBox, {
                                          "data-source": _ctx.shadeData.length ? _ctx.shadeData : [],
                                          "data-text-field": 'text',
                                          "data-value-field": 'value',
                                          height: 130,
                                          filter: 'contains',
                                          key: 'id',
                                          modelValue: _ctx.shadeDataArray[id],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.shadeDataArray[id]) = $event),
                                          value: _ctx.shadeDataArray[id],
                                          style: {"width":"9em !important","font-size":"12px !important"}
                                        }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "value"]))
                                      ]),
                                      _createElementVNode("td", null, [
                                        (_openBlock(), _createBlock(_component_ComboBox, {
                                          "data-source": _ctx.packageSizeData[id] && _ctx.packageSizeData[id].length ? _ctx.packageSizeData[id] : [],
                                          "data-text-field": 'text',
                                          "data-value-field": 'value',
                                          height: 130,
                                          filter: 'contains',
                                          key: 'id',
                                          modelValue: _ctx.packageSizeDataArray[id],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.packageSizeDataArray[id]) = $event),
                                          value: _ctx.packageSizeDataArray[id],
                                          style: {"width":"7em !important","font-size":"12px !important"}
                                        }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "value"]))
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("tbody", _hoisted_64, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentDisplayRows, (row, rid) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: rid,
                                      class: _normalizeClass({ headRow: row.isHead, componentRow: row.divisor > 1 })
                                    }, [
                                      _createElementVNode("td", _hoisted_65, [
                                        _createTextVNode(_toDisplayString(row.displayName) + " ", 1),
                                        (row.isHead)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_66, " (" + _toDisplayString(row.heads) + ")", 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(row.divisor > 1 ? row.consumption : _ctx.consumptionValues[row.headPosition]), 1),
                                      (row.isHead)
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_67, _toDisplayString(_ctx.$t("editComponent.chosenPerComponentBelow")), 1))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createElementVNode("td", null, [
                                              (_ctx.brandData.length)
                                                ? (_openBlock(), _createBlock(_component_ComboBox, {
                                                    "data-source": _ctx.brandData.length ? _ctx.brandData : [],
                                                    "data-text-field": 'text',
                                                    height: 130,
                                                    "data-value-field": 'value',
                                                    filter: 'contains',
                                                    key: 'id',
                                                    modelValue: _ctx.brandIdDataArray[row.leafIndex],
                                                    "onUpdate:modelValue": ($event: any) => ((_ctx.brandIdDataArray[row.leafIndex]) = $event),
                                                    value: _ctx.brandIdDataArray[row.leafIndex],
                                                    style: {"width":"10em !important","font-size":"12px !important"},
                                                    onChange: ($event: any) => (_ctx.handleBrandChange($event.sender._cascadedValue, row.leafIndex))
                                                  }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "value", "onChange"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("td", null, [
                                              (_openBlock(), _createBlock(_component_ComboBox, {
                                                "data-source": 
                                _ctx.tktTexData[row.leafIndex] && _ctx.tktTexData[row.leafIndex].length
                                  ? _ctx.tktTexData[row.leafIndex]
                                  : []
                              ,
                                                "data-text-field": 'text',
                                                "data-value-field": 'value',
                                                height: 130,
                                                filter: 'contains',
                                                key: 'id',
                                                modelValue: _ctx.tktTexDataArray[row.leafIndex],
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.tktTexDataArray[row.leafIndex]) = $event),
                                                value: _ctx.tktTexDataArray[row.leafIndex],
                                                style: {"width":"7em !important","font-size":"12px !important"},
                                                onChange: ($event: any) => (_ctx.handleTktTexChange($event.sender._cascadedValue, row.leafIndex))
                                              }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "value", "onChange"]))
                                            ]),
                                            _createElementVNode("td", null, [
                                              (_openBlock(), _createBlock(_component_ComboBox, {
                                                "data-source": _ctx.shadeData.length ? _ctx.shadeData : [],
                                                "data-text-field": 'text',
                                                "data-value-field": 'value',
                                                height: 130,
                                                filter: 'contains',
                                                key: 'id',
                                                modelValue: _ctx.shadeDataArray[row.leafIndex],
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.shadeDataArray[row.leafIndex]) = $event),
                                                value: _ctx.shadeDataArray[row.leafIndex],
                                                style: {"width":"9em !important","font-size":"12px !important"}
                                              }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "value"]))
                                            ]),
                                            _createElementVNode("td", null, [
                                              (_openBlock(), _createBlock(_component_ComboBox, {
                                                "data-source": 
                                _ctx.packageSizeData[row.leafIndex] && _ctx.packageSizeData[row.leafIndex].length
                                  ? _ctx.packageSizeData[row.leafIndex]
                                  : []
                              ,
                                                "data-text-field": 'text',
                                                "data-value-field": 'value',
                                                height: 130,
                                                filter: 'contains',
                                                key: 'id',
                                                modelValue: _ctx.packageSizeDataArray[row.leafIndex],
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.packageSizeDataArray[row.leafIndex]) = $event),
                                                value: _ctx.packageSizeDataArray[row.leafIndex],
                                                style: {"width":"7em !important","font-size":"12px !important"}
                                              }, null, 8, ["data-source", "modelValue", "onUpdate:modelValue", "value"]))
                                            ])
                                          ], 64))
                                    ], 2))
                                  }), 128))
                                ]))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.showHeader && !_ctx.isV4CalculationEngine)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(_ctx.$t("styleGrid.threadWastageNote")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        style: {"width":"7rem","border-radius":"5px"},
                        onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.onSaveOperationData && _ctx.onSaveOperationData(...args)))
                      }, _toDisplayString(_ctx.$t("operationCreateComp.save")), 1),
                      _createElementVNode("button", {
                        class: "btn btn-secondary",
                        style: {"width":"8rem","border-radius":"5px","margin-left":"10px"},
                        onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.handleDialogClose && _ctx.handleDialogClose(...args)))
                      }, _toDisplayString(_ctx.$t("operationCreateComp.cancel")), 1)
                    ])
                  ])
                ], 2)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}